import { Image } from '@ds';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';
import { MdOutlineSettings } from 'react-icons/md';
import { NotificationMessageType, NotificationType } from '@/api/apis/communication';
import { getColorsByOrganType, getOrganImg } from '@/utils/helpers';
import { formatCreatedAt, getCustomCaseNotificationBody } from '../config';
import { OrganType } from '@/api/apis/case';
import { getCaseNotificationLink } from './utils';

const containerClassNames = 'w-[776px] p-3 bg-white rounded-lg shadow items-start gap-2 inline-flex justify-between';
const bulkOperations = [
  NotificationMessageType.CaseBulkSwapOperationCompleted,
  NotificationMessageType.CaseBulkAssignOperationCompleted,
  NotificationMessageType.CaseBulkDetachOperationCompleted,
  NotificationMessageType.CaseBulkOperationPrimaryElevation,
];

const bulkCompletedEvents = [
  NotificationMessageType.CaseBulkSwapOperationCompleted,
  NotificationMessageType.CaseBulkAssignOperationCompleted,
  NotificationMessageType.CaseBulkDetachOperationCompleted,
];

export const CaseNotification = ({ notification }: { notification: NotificationType }) => {
  const { category, heading, eventText, createdAt, notificationType } = notification;
  const colors = getColorsByOrganType(category as OrganType);
  const createAtTime = useMemo(() => formatCreatedAt(createdAt), [createdAt]);
  const isBulkOperation = bulkOperations.includes(notificationType);
  const img = getOrganImg(category as OrganType);
  const showEventText = !bulkCompletedEvents.includes(notificationType);

  const content = (
    <>
      <div className="flex flex-row gap-2 justify-start min-w-0">
        <div className={`shrink-0 h-5 w-5 flex justify-center items-center ${colors.bg40} rounded-2xl`}>
          {img ? <Image src={img} className="h-3 w-3 object-contain shrink-0" /> : <MdOutlineSettings />}
        </div>
        <div className="flex-1 min-w-0 flex flex-col gap-2 justify-between pl-1">
          <span className={`text-xs-sb ${colors.textSaturated} truncate`} title={heading}>
            {heading}
          </span>
          <div className="flex flex-col gap-0.5">
            {showEventText && <span className="text-m-m text-base-5 wrap-break-word line-clamp-2">{eventText}</span>}
            {getCustomCaseNotificationBody(notification)}
          </div>
        </div>
      </div>
      <div className="flex items-end shrink-0">
        <span className="text-xs-r text-base-20">{createAtTime}</span>
      </div>
    </>
  );

  if (isBulkOperation) {
    return <div className={containerClassNames}>{content}</div>;
  }

  return (
    <Link to={getCaseNotificationLink(notification)} className={containerClassNames}>
      {content}
    </Link>
  );
};
